var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_page"},[_c('v-alert',{attrs:{"value":true,"type":"error"}},[_c('h3',[_vm._v(_vm._s(_vm.label))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }